module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"attention":"Attention","confirm delete slide":"The content of this slide will be deleted. Continue?","copy of":"Copy of {title}","soft limit slides reached":"The recommenden number of slides ({limit}) is exceeded..."}}')
  delete Component.options._Ctor
}
